module.exports = __webpack_public_path__ + "img/naotu_5.8eafc196.png";